
import { useSelector, useDispatch } from 'react-redux'
import { unset_updatemeeting} from '../slice/mainslice'
import { UserInMeeting } from './UserInMeeting';
import { NotarUserInMeeting } from './NotarUserInMeeting';
import { DocInMeeting } from './DocInMeeting';
import { Logout,   } from 'tabler-icons-react';
import { Text, Title, Grid, Group, Avatar,Indicator,createStyles, ActionIcon, Notification, rem, Modal, Button, Tooltip} from '@mantine/core';
import { setdisplaywidth } from '../slice/mainslice';
import { LayoutColumns, LayoutRows, ArrowBarToRight, Check, Video } from 'tabler-icons-react';
import { useState } from 'react';
import intl from 'react-intl-universal';
import ClientChangeLanguage from '../helperforall/ClientChangeLanguage';


const useStyles = createStyles((theme) => ({
    padtop10: {
      paddingTop: `10px`,
    },
    textsize: {
      fontSize: rem('16px'),
      [theme.fn.smallerThan('lg')]: {
        fontSize: rem('10px'),
      },
    },
    itemTitle: {
      fontSize: rem('16px'),
      [theme.fn.smallerThan('lg')]: {
        fontSize: rem('12px'),
      },
    },
  }));


/**
 * Renders the UserToolsView component.
 * 
 * Sidebar with UserInMeeting, DocInMeeting and SignDocInMeeting
 *
 * @meuser: {Object} - state.user.meuser - The current user.
 * @meetinguser: {Object} - state.user.meetinguser - The current meeting user.
 * @meetinginfo: {Object} - state.user.meetinginfo - The current meeting information.
 * @showdoc: {Object} - state.user.showmeetingdocs - Objekt der Dokumente im Meeting.
 * @showsigndoc: {Object} - state.user.showsignmeetingdocs - Objekt des Dokumentes to Sign.
 * @updatemeetingdate: {boolean} - state.user.updatemeetingdate - Have Meeting Changed?
 * 
 * @return {JSX.Element} The rendered component.
 */
const UserToolsView = (props: any) => {
    const { classes } = useStyles();
    const dispatch = useDispatch()
    const meuser = useSelector((state: any) => state.user.meuser)
    const meetinguser = useSelector((state: any) => state.user.meetinguser)
    const meetinginfo = useSelector((state: any) => state.user.meetinginfo)
    const showdoc = useSelector((state: any) => state.user.showmeetingdocs)
    const showsigndoc = useSelector((state: any) => state.user.showsignmeetingdocs)
    const updatemeetingdate = useSelector((state: any) => state.user.updatemeetingdate)
    const [logoutopened, setLogoutopened] = useState(false);

    const closemessage = () => {
      dispatch(unset_updatemeeting())
    }

    let a = meuser.lastName.substring(0,1)
    let b = meuser.firstName.substring(0,1)
    let initialen = a + b
    let fullname = meuser.lastName + " " + meuser.firstName

    /**
     * A function that handles the logout process by setting 'logoutopened' to true.
     *
     * @return {void} 
     */
    const handleLogout = () => {
      setLogoutopened(true);
    };

  /**
   * Sets the state of `logoutopened` to `false`, closing the logout modal.
   *
   * @return {void} 
   */
    const handleLogoutclose = () => {
      setLogoutopened(false);
    };
  

  /**
   * Handles the click event when the user confirms the logout.
   * Sends a request to the server to close the meeting.
   * closes the logout modal.
   * @return {void} .
   */
    const handleLogoutYesClick = () => {
      sentlogoutcommand();
      handleLogoutclose();
    };
  
    /**
     * A description of the entire function.
     * closes the logout modal.
     * @return {type} 
     */
    const handleLogoutNoClick = () => {
      handleLogoutclose();
    };   

  /**
   * Sends a logout command to close the current document in SignalR
   * @return {void} 
   */
    const sentlogoutcommand = () => {
      const handlelogoutpayload = {
        drnId: meetinginfo.drnId,
        command: "closedoc"   
      }; 
      dispatch({ type: 'SIGNALR_SENDCLOSEMEETING', payload: handlelogoutpayload });
    }

    // Status Abzeige Online UserMe ()
    const meuserstatus = meetinguser.filter((obj: { id: any; }) => {
    return obj.id === meuser.id
    });
  
    let userstatuscolor = "red";
    if(meuserstatus[0].meetingParticipantStatus === "LeftMeeting") {
      userstatuscolor = "red";
    }
    if(meuserstatus[0].meetingParticipantStatus === "InMeeting") {
      userstatuscolor = "green";
    }
   
  return (
    <>
     <Grid >
    
      <Grid.Col xs={8} md={8} lg={8} >
        <Group position="left" className={classes.padtop10}>
          <Indicator inline size={10} offset={2} position="bottom-end" color={userstatuscolor} withBorder >
              <Avatar  variant="filled" radius="xl" size="sm">{initialen}</Avatar>
          </Indicator>
            <span className={classes.textsize}><b>{fullname}</b> </span>
        </Group> 
      </Grid.Col>
      <Grid.Col xs={4} md={4} lg={4}>
        <Group position="right" className={classes.padtop10}>
          <Tooltip label={intl.get('TOOLSVIEW_SMALL')} multiline={true}><span> <ArrowBarToRight size={30}  onClick={() => props.setOpentool(false)}/> </span></Tooltip>    
          <Tooltip label={intl.get('TOOLSVIEW_LOGOUT')} multiline={true}><span> <Logout size={30} strokeWidth={1} color={'black'} onClick={handleLogout}/></span></Tooltip>
        </Group>
      </Grid.Col>
    </Grid>
    <hr /> 
    <Grid >
      <Grid.Col xs={10}  md={10}>
        <Group>
          <Video size={rem(30)} color="gray" />
          <Title order={5} className={classes.textsize}> {meetinginfo.title}</Title>
        </Group>
      </Grid.Col>
      <Grid.Col xs={2} md={2}>
        <Group position="right" >
          <ClientChangeLanguage />
        </Group>
      </Grid.Col>
    </Grid>
    <hr />
      <Title order={3} className={classes.textsize}>{intl.get('USERTOOLSVIEW_STRUK_1')}</Title>
    <hr />
      <NotarUserInMeeting />
    <hr />
      <Title order={3} className={classes.textsize}>{intl.get('USERTOOLSVIEW_STRUK_2')}</Title>
    <hr />
      <UserInMeeting />

      <Title order={3} className={classes.textsize}>{intl.get('USERTOOLSVIEW_STRUK_3')}</Title>
    <hr />
      <DocInMeeting />

      {updatemeetingdate &&
          <Notification onClose={()=>closemessage()} icon={<Check size="1.1rem" />} color="teal" title={intl.get('USERTOOLSVIEW_NOTE_HEAD')}>
            {intl.get('USERTOOLSVIEW_NOTE_TEXT')}
          </Notification>
      }    

    {showdoc.resourceId !== undefined  &&
              <>
                <hr />
                <Title order={3}>{intl.get('TOOLSVIEW_LAYOUT_HEAD')}</Title>
                <Group position="left">
                  <ActionIcon variant="outline" size="xl" aria-label="Settings" onClick={() => dispatch(setdisplaywidth(1))}>
                        <LayoutRows style={{ width: '70%', height: '70%' }}   />
                  </ActionIcon>
                  <ActionIcon variant="outline" size="xl" aria-label="Settings" onClick={() => dispatch(setdisplaywidth(2))}>
                        <LayoutColumns style={{ width: '70%', height: '70%' }}   />
                  </ActionIcon>
                </Group>
              </>
    }
    {showsigndoc.resourceId !== undefined  &&
                <>
                <hr />
                  <Title order={3}>{intl.get('TOOLSVIEW_LAYOUT_HEAD')}</Title>
                  <Group position="left">
                    <ActionIcon variant="outline" size="xl" aria-label="Settings" onClick={() => dispatch(setdisplaywidth(1))}>
                          <LayoutRows style={{ width: '70%', height: '70%' }}   />
                    </ActionIcon>
                    <ActionIcon variant="outline" size="xl" aria-label="Settings" onClick={() => dispatch(setdisplaywidth(2))}>
                          <LayoutColumns style={{ width: '70%', height: '70%' }}   />
                    </ActionIcon>
                  </Group>
                </>
    }

      <Modal
        title={intl.get('TOOLSVIEW_MODAL_ENDMEETING')}
        opened={logoutopened}
        onClose={handleLogoutclose}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="md"
        shadow="sm"
        centered
        >
          <Text>{intl.get('TOOLSVIEW_MODAL_ENDMEETING_TEXT')}  </Text>
          <hr />
          <Grid>
            <Grid.Col span={6}>
                <Button fullWidth color="green" onClick={handleLogoutYesClick}>{intl.get('DIALOG_BUTTON_YES')}</Button>
            </Grid.Col>
            <Grid.Col span={6}>
                <Button fullWidth color="red" variant="light" onClick={handleLogoutNoClick}>{intl.get('DIALOG_BUTTON_NO_CLOSE')}</Button>
            </Grid.Col>
          </Grid>
      </Modal> 
    </>
  );
}

export default UserToolsView ;